import preset from "./preset-theme";
import { extendTheme } from "@chakra-ui/react"

export const theme = extendTheme(preset)
